export enum HouseCategory {
    UNKNOWN = 0,
    STANDALONE = 1,
    PART_OF_HOUSE = 2,
    DUPLEX = 3,
    TOWNHOUSE = 4
}
